import React, { useRef } from 'react';
import { Pressable, StyleSheet, View } from 'react-native';
import { BodyText, Icon, theme, usePressableState } from '@sg/garnish';

// ────────────────────────────────────────────────────────────────────────────

export const BagPaymentMethodAddCta = (props: AddCtaProps) => {
  const ref = useRef(null);
  const { isInteracting } = usePressableState(ref);

  return (
    <Pressable
      ref={ref}
      style={[styles.addCta, isInteracting ? styles.addCtaInteracting : null]}
      accessibilityRole="button"
      accessibilityLabel={props.title}
      onPress={props.onPress}
    >
      <View style={styles.iconWrapper}>
        <Icon name="IconPlus" width={ICON_SIZE} height={ICON_SIZE} />
      </View>

      <BodyText sizeMatch={['24']}>{props.title}</BodyText>
    </Pressable>
  );
};

// ─── Constants ──────────────────────────────────────────────────────────────

const ICON_SIZE = 24;
const ICON_WRAPPER_SIZE = 32;

// ─── Styles ─────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  addCta: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing['2'],
    paddingLeft: theme.spacing['2'],
    paddingVertical: theme.spacing['1'],
    borderRadius: theme.radius.xxxlarge,
  },
  addCtaInteracting: {
    backgroundColor: theme.colors.OPACITY.DARK_KALE.ALMOST_TRANSPARENT,
    borderRadius: theme.radius.xxxlarge,
  },
  iconWrapper: {
    alignItems: 'center',
    justifyContent: 'center',
    width: ICON_WRAPPER_SIZE,
    height: ICON_WRAPPER_SIZE,
  },
});

// ─── Types ──────────────────────────────────────────────────────────────────

type AddCtaProps = {
  title: string;
  onPress: () => void;
};
